import React, { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { Alert, AlertTitle, Typography } from '@mui/material';
import { apiClient } from '../../utils/apiClient';
import type { OverdueKiosk } from './types';

type State = { kind: 'loading' } | { kind: 'loaded'; rows: OverdueKiosk[] } | { kind: 'failed' };

export const OverdueBanner = () => {
  const translate = useTranslate();
  const [state, setState] = useState<State>({ kind: 'loading' });
  useEffect(() => {
    let cancelled = false;
    apiClient
      .get<{ data: OverdueKiosk[] }>('/api/backend/kiosk-settlements/overdue')
      .then((response) => {
        if (!cancelled) setState({ kind: 'loaded', rows: response.data });
      })
      .catch(() => {
        if (!cancelled) setState({ kind: 'failed' });
      });
    return () => {
      cancelled = true;
    };
  }, []);
  if (state.kind === 'loading') return null;
  if (state.kind === 'failed') return <Alert severity="error">{translate('resources.kiosk-settlements.overdue.loadFailed')}</Alert>;
  if (state.rows.length === 0) return null;
  return (
    <Alert severity="warning" data-testid="settlements-overdue">
      <AlertTitle>{translate('resources.kiosk-settlements.overdue.title')}</AlertTitle>
      {state.rows.map((row) => (
        <Typography key={row.kioskId} variant="body2">
          {row.lastSettledAt === null
            ? translate('resources.kiosk-settlements.overdue.never', { kiosk: row.kioskName, site: row.siteName })
            : translate('resources.kiosk-settlements.overdue.line', { kiosk: row.kioskName, site: row.siteName, at: new Date(row.lastSettledAt).toLocaleString(), hours: row.hoursSinceLastSettlement })}
        </Typography>
      ))}
    </Alert>
  );
};
